export const FOLDER_COLORS = ['#FC4F67', '#D9BADD', '#E59767', '#EEEEEF', '#AEAEAE', '#F8B856', '#88A698', '#B6957E', '#E8E6D0', '#93C6D9', '#93A688', '#B89CAA'];

export function getBackgroundColor(index: number) {
    const colors = FOLDER_COLORS;

    return colors[index % colors.length];
}
